<template>
  <div>
    <ais-instant-search
      :search-client="searchClient"
      :index-name="index"
    >
      <ais-configure
        :distinct="true"
        :facet-filters.camel="facetFilters()"
      />

      <ais-hits
        class="app-content"
        role="main"
      >
        <icon-does-not-exist
          class="app-content"
          icon-name="packs"
          selected-style="solid"
          selected-family="classic"
          :version="version"
        />
      </ais-hits>
    </ais-instant-search>
  </div>
</template>

<script>
  import algoliasearch from 'algoliasearch/lite'
  import { fetchIndexName } from 'app/views/search/utils'
  import { IconsMixins } from 'app/views/icons/components/icons/mixins'
  import IconDoesNotExist from 'app/views/icons/components/icons/details/IconDoesNotExist'

  export default {
    name: 'IconPackDisabled',

    components: {
      IconDoesNotExist
    },

    mixins: [IconsMixins],

    prop: {
      iconName: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        icon: { membership: { free: [], pro: [] }, aliases: {}, styles: [], sponsored: {}, changes: [] },
        searchClient: algoliasearch(FONTAWESOME.ALGOLIA_APPLICATION_ID, FONTAWESOME.ALGOLIA_SEARCH_API_KEY)
      }
    },

    computed: {
      index() {
        return fetchIndexName(this.$releases.active.version)
      },

      version() {
        return this.$releases.active.versionParts.major
      }
    },

    methods: {
      facetFilters() {
        return [[`objectID:packs`]]
      }
    }
  }
</script>
